import axios from 'axios'

const apiClient = axios.create({
  baseURL: 'https://dashamajig.chibitronics.com/api',
  withCredentials: false,
  headers: { Accept: 'application/json', 'Content-Type': 'application/json' }
})

function authHeaders() {
  const token = localStorage.getItem('token')
  if (!token) return {}
  return { Authorization: `Bearer ${token}`, 'X-Auth-Token': token }
}

export const CONDUIT_LEVELS = [
  { level: 1, label: 'Made the connection' },
  { level: 2, label: 'Pitched specific products' },
  { level: 3, label: 'Sent a quote' },
  { level: 4, label: 'Verbal approval given' },
  { level: 5, label: 'Purchase order completed' }
]

export default {
  searchVariants(q) {
    return apiClient.get('/shopify/variants', { params: { q }, headers: authHeaders() })
  },

  listAll(params = {}) {
    return apiClient.get('/estimates', { params, headers: authHeaders() })
  },

  listByCompany(companyName) {
    return apiClient.get('/companies/estimates', {
      params: { company: companyName },
      headers: authHeaders()
    })
  },

  list(customerId) {
    return apiClient.get(`/customers/${customerId}/estimates`, { headers: authHeaders() })
  },

  get(customerId, estimateId) {
    return apiClient.get(`/customers/${customerId}/estimates/${estimateId}`, { headers: authHeaders() })
  },

  create(customerId, payload) {
    return apiClient.post(`/customers/${customerId}/estimates`, payload, { headers: authHeaders() })
  },

  update(customerId, estimateId, payload) {
    return apiClient.patch(`/customers/${customerId}/estimates/${estimateId}`, payload, {
      headers: authHeaders()
    })
  },

  destroy(customerId, estimateId) {
    return apiClient.delete(`/customers/${customerId}/estimates/${estimateId}`, {
      headers: authHeaders()
    })
  },

  pdfUrl(customerId, estimateId) {
    return `${apiClient.defaults.baseURL}/customers/${customerId}/estimates/${estimateId}/pdf`
  }
}
